import { Box, Container, Typography, Button } from '@mui/material';
import BackgroundImage from "../../images/background.jpg";

import AndroidIcon from '@mui/icons-material/Android';
import LaunchIcon from '@mui/icons-material/Launch';

const HeroSection = () => {
    return (
        <Box
            sx={{
                position: 'relative',
                bgcolor: 'grey.800',
                color: 'white',
                py: { xs: 8, md: 12 },
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: `url(${BackgroundImage})`,
            }}
        >
            {/* Dark overlay for text readability */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                }}
            />
            <Container maxWidth="md" sx={{ position: 'relative' }}>
                <Typography
                    component="h1"
                    variant="h2"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '2.8rem', sm: '4rem' },
                        color: "white",
                    }}
                >
                    We are the Future!
                </Typography>
                <Typography variant="h5" align="center" paragraph>
                    Connecting students with qualified, passionate tutors to unlock the potential of the next generation.
                </Typography>
                <Box 
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    gap: 2, 
                    mt: 4, 
                    px: 2 
                }}
                >
                {/* Primary Action Button */}
                    <Button 
                        variant="contained" 
                        color="primary" 
                        component="a"
                        href="https://app.ethiofuturetutor.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        endIcon={<LaunchIcon sx={{ fontSize: '0.8rem' }} />}
                        sx={{
                        px: { xs: 3, md: 4 },
                        py: { xs: 1.2, md: 1.8 },
                        fontSize: { xs: '0.95rem', md: '1.15rem' },
                        fontWeight: 'bold',
                        borderRadius: '6px',
                        textTransform: 'none',
                        boxShadow: 3,
                        width: { xs: '100%', sm: 'auto' },
                        // Wider maximum width allowed on desktop to prevent text crowding
                        maxWidth: { xs: '280px', md: '340px' },
                        textAlign: 'center',
                        }}
                    >
                        Get Started on Web
                    </Button>

                    {/* Solid Android Button */}
                    <Button 
                        variant="contained" 
                        component="a"
                        href="https://play.google.com/store/apps/details?id=com.ethiofuturetutor.app" 
                        target="_blank"
                        rel="noopener noreferrer"
                        startIcon={<AndroidIcon />}
                        sx={{
                        px: { xs: 3, md: 4 },
                        py: { xs: 1.2, md: 1.8 }, 
                        fontSize: { xs: '0.95rem', md: '1.15rem' }, 
                        fontWeight: 'bold',
                        borderRadius: '6px',
                        textTransform: 'none',
                        width: { xs: '100%', sm: 'auto' },
                        // Wider cap on desktop forces the string onto a single line
                        maxWidth: { xs: '280px', md: '340px' },
                        
                        backgroundColor: '#f5f5f5', 
                        color: '#1a1a1a', 
                        boxShadow: 3,
                        whiteSpace: 'nowrap', // Hard guarantee the string stays single-line
                        
                        '&:hover': {
                            backgroundColor: '#e0e0e0',
                            boxShadow: 5,
                        }
                        }}
                    >
                        Download Android App
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};

export default HeroSection;